import { render, staticRenderFns } from "./InvoicePaymentButton.vue?vue&type=template&id=f9b01d0e"
import script from "./InvoicePaymentButton.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports